<template>
  <div :class="$style.wrap">
    <!-- 解锁提示 -->
    <template v-if="active == 0">
      <template v-if="allLock != 1">
        <lock-status :isLock="String(isLock)" :phone="phone" />
        <!-- 请求手机是否绑定 到下一步 -->
        <van-button
          round
          type="primary"
          size="large"
          tag="input"
          :value="buttonName"
          native-type="submit"
          @click.stop.prevent="onLock(0)"
        />
      </template>
      <!-- 巫神解锁 -->
      <template v-if="gameId == 5 && overLockServe.length != 0">
        <bind-server :overLockServe="overLockServe" />
        <van-button
          round
          type="primary"
          size="large"
          tag="input"
          value="解锁"
          native-type="submit"
          @click.stop.prevent="onLock(1)"
        />
      </template>
    </template>
    <!-- 发送短信 -->
    <template v-else-if="active == 1">
      <phone-verification :phone="sLoginCode" style="margin-top:0.5rem" />
      <base-form
        ref="form"
        :key="active"
        :currentIndex="active"
        :actions="actions"
        :items="data"
        label-width="3em"
        submit-text="确定"
        @giveData="giveData"
        @actionShow="handlerAction"
        @setActionValue="setActionValue"
        @submit="onSubmit"
      />
    </template>
  </div>
</template>
<script>
import { minxinActive } from "@/mixins/minxinActive";
import {
  getGameCodeStatus,
  isBindPhone,
  LockAndUnlock,
  getServerList
} from "@/http/serve";
import { mapGetters, mapActions } from "vuex";
import phoneVerification from "../../components/PhoneVerification";
import lockStatus from "./components/lockStatus";
import bindServer from "./components/bindServer";
import BaseForm from "@/components/BaseForm";

export default {
  name: "LockAccount",
  components: {
    phoneVerification,
    lockStatus,
    bindServer,
    BaseForm
  },
  mixins: [minxinActive],
  data() {
    return {
      allLock: 1, //巫神是否全锁定
      actions: [], //picker选项
      overLockServe: [], //已锁定的服务器
      phone: this.$ls.get("phone") || "", //手机号,
      sLoginCode: this.$ls.get("sLoginCode") || "", //手机号
      isLock: this.$ls.get("isLock") || 0, //1 锁定-对应要解锁 0 未锁定 -对应要锁定
      dataList: this.$ls.get("dataList") || [
        { title: "第一步", filed: [] },
        {
          title: "第二步",
          filed: [
            {
              name: "server",
              readonly: true,
              iconType: 1,
              actions: []
            },
            {
              name: "telCode",
              moduleType: true,
              type: this.isLock ? 16 : 15
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.SetLeave(false);
    //进页面先判断是否锁定
    this.getLockStatus();
    this.setDataList();
  },
  computed: {
    ...mapGetters(["gameName", "gameId"]),
    buttonName() {
      let name = "";
      this.gameId == 5
        ? (name = "锁定")
        : this.isLock
        ? (name = "解锁")
        : (name = "锁定");

      return name;
    },
    data() {
      return this.dataList[this.active].filed;
    }
  },
  methods: {
    ...mapActions(["SetTitle", "SetLeave"]),
    /**
     * @description 初始化步骤 魔侠无服务器选择
     */
    setDataList() {
      if (this.gameId == 5) return false;
      //魔侠无服务器选择
      this.dataList[1].filed.length == 2 && this.dataList[1].filed.splice(0, 1);
    },
    /**
     * @description 解锁/锁定
     * @param {number} type  - 获取服务器类型解锁/锁定
     */
    onLock(type) {
      this.isBindePhone();
      if (this.gameId != 5) return false;
      //根据按钮判断是去锁定还是解锁
      this.isLock = type;
      this.$ls.set("isLock", this.isLock);
    },
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      this.handlerLock(formdata);
    },
    /**
     * @description 是否绑定手机
     */
    async isBindePhone() {
      let res = await isBindPhone();
      let { rcode, data } = res;
      if (rcode == 5003) {
        this.$Dialog
          .confirm({
            title: `您还未绑定手机，暂无法${this.isLock ? "解锁" : "锁定"}账号`,
            message: "是否去绑定手机号？",
            confirmButtonText: "立即绑定",
            cancelButtonText: "我知道了"
          })
          .then(() => {
            //绑定手机父级变为lockAccout
            this._anchor.bindPhone.meta.parent = "lockAccount";
            this.$router.replace({
              path: this._anchor.bindPhone.path,
              query: {
                path: this._anchor.lockAccount.path
              }
            });
          })
          .catch(() => {
            // on cancel
          });
        return false;
      }
      if (rcode != 0) return;
      this.sLoginCode = data.s_login_code;
      this.$ls.set("sLoginCode", this.sLoginCode);
      //巫神请求服务器 ，魔侠直接进入到下一步
      this.gameId == 5 ? this.getServerList() : this.setActive();
    },
    /**
     * @description 巫神获取可绑定或可解锁的服务器
     */
    async getServerList() {
      let parmas = {
        game_id: 5,
        type: this.isLock + 1
      };
      let res = await getServerList(parmas);
      let { rcode, data } = res;
      if (rcode != 0) {
        this.handlerForm();
        return false;
      }
      //设置发送验证码请求类型
      this.setFieldValue(1, "telCode", this.isLock ? 16 : 15, "type");
      //设置第二步服务器数据
      this.setFieldValue(1, "server", data, "actions");
      //设置第二步的title
      this.handlerTitle();
      this.setActive();
    },
    /**
     * @description 可绑定或可解锁的锁定信息
     */
    handlerLockInfo() {
      if (this.gameId == 3) {
        this.handlerTitle();
        return false;
      }
      //巫生第一步标题都是账号
      if (this.active == 0) {
        if (this.overLockServe.length == 0) {
          this.SetTitle(`${this.gameName}· 锁定账号`);
        } else {
          this.allLock
            ? this.SetTitle(`${this.gameName}· 解锁账号`)
            : this.SetTitle(`${this.gameName}· 锁定/解锁账号`);
        }
      } else {
        this.handlerTitle();
      }
    },
    /**
     * @description 控制头部的title
     */
    handlerTitle() {
      this.$ls.get("isLock")
        ? this.SetTitle(`${this.gameName}· 解锁账号`)
        : this.SetTitle(`${this.gameName}· 锁定账号`);
    },
    /**
     * @description 设置picker选中值
     */
    setActionValue(index, item) {
      let { text, id } = item;
      this.setFieldValue(1, "server", id, "id");
      this.setFieldValue(1, "server", text);
    },
    /**
     * @description 锁定/解锁
     * @param {object} formdata  - 表单对象值
     */
    async handlerLock(formdata) {
      let { telCode } = formdata;
      let params = {
        type: this.isLock ? 16 : 15,
        game_id: this.gameId,
        code: telCode
      };
      //巫神需传递服务器ID
      if (this.gameId == 5) {
        params.server_id = this.getFieldValue(1, "server", "id");
      }
      let res = await LockAndUnlock(params);
      if (res.rcode != 0) {
        this.handlerForm();
        return false;
      }

      //重新刷新状态
      await this.getLockStatus();
      await this.hanlderMessage();
    },
    /**
     * @description 获取账号锁定状态
     */
    async getLockStatus() {
      let parmas = {
        game_id: this.gameId
      };
      let res = await getGameCodeStatus(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      let { lock_status, s_login_code } = data;
      //巫神id为5根据服务判断
      if (this.gameId == 5) {
        this.overLockServe = data.server;
        //是否全锁定
        this.allLock = data.all_lock;
      } else {
        this.allLock = 0;
        //锁定状态
        this.isLock = lock_status;
        this.$ls.set("isLock", this.isLock);
        this.setFieldValue(
          1,
          "telCode",
          this.$ls.get("isLock") ? 16 : 15,
          "type"
        );
      }
      this.phone = s_login_code;
      this.$ls.set("phone", this.phone);
      this.handlerLockInfo();
    },
    /**
     * @description 提示信息显示
     */
    hanlderMessage() {
      this.handlerForm();
      if (this.gameId != 5) {
        //已被锁定
        if (!this.isLock) {
          this.$Dialog
            .confirm({
              title: "解锁成功，账号可正常登录魔侠传",
              message: "解锁后建议尽快修改密码",
              confirmButtonText: "修改密码",
              cancelButtonText: "我知道了"
            })
            .then(() => {
              this.resetData();
              this.SetLeave(true);
              this.$router.replace({
                path: this._anchor.password.path
              });
            })
            .catch(() => {
              this.resetData();
            });

          return false;
        }
        this.$Dialog
          .alert({
            title: "锁定成功",
            message: `锁定期间账号将不能登录《${this.gameName}》`
          })
          .then(() => {
            this.resetData();
          });
      } else {
        //巫神
        let serverName = this.getFieldValue(1, "server");
        if (!this.isLock) {
          this.$Dialog
            .alert({
              title: "锁定成功",
              message: `锁定期间账号将不能登录${serverName}`
            })
            .then(() => {
              this.resetData();
              this.handlerLockInfo();
            });
          return false;
        }
        this.$Dialog
          .alert({
            title: `解锁成功，账号可正常登录${serverName}`
          })
          .then(() => {
            this.resetData();
            this.handlerLockInfo();
          })
          .catch(() => {
            this.resetData();
            this.handlerLockInfo();
          });
      }
    },
    /**
     * @description 重置页面数据变为初始
     */
    resetData() {
      //清空验证码
      this.resetFieldValue(1, "telCode");
      //清除服务器选择
      this.gameId == 5 && this.resetFieldValue(1, "server");
      //清空第二步填的服务器
      this.setFieldValue(1, "telCode", this.isLock ? 16 : 15, "type");
      this.active = 0;
      this.$ls.set("active", this.active);
    },
    /**
     * @description 页面步骤回退
     */
    goBack() {
      if (this.active === 1) {
        //清空验证码
        this.resetFieldValue(1, "telCode");
        //清空第二步填的服务器
        this.gameId == 5 && this.resetFieldValue(1, "server");
        //重新刷新锁定状态
        this.getLockStatus();
        this.backActive();
        return false;
      }
      return true;
    },
    /**
     * @description 移除存储数据
     */
    removeAll() {
      let lsList = ["sLoginCode", "active", "dataList", "isLock", "phone"];
      this.lsRemove(lsList);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  .size(100%, auto);
  .flex-center;
  .flex-col;
  padding-top: 1.5rem;
}
</style>
